import axios from '@/libs/api.request'

/**
 * 获取机构树
 */
export const getOrgTreeData = () => {
    return axios.request({
        url: '/api/admin/org/tree',
        method: 'post'
    })
}

/**
 * 工程划分树
 */
export const getProjectDivisionTreeData = (type) => {
    const data = {
        'type': type
    }
    return axios.request({
        url: '/api/admin/projectdivision/tree',
        data,
        method: 'post'
    })
}

/**
 * 获取工程划分树父名称
 */
export const getProjectDivisionParentNames = (pid) => {
    const data = {
        'pid': pid
    }
    return axios.request({
        url: '/api/admin/projectdivision/getParentNames',
        data,
        method: 'post'
    })
}

/**
 * 根据分部ID获取单元列表
 */
export const getUnitListByBranch = (branch_code) => {
    const data = {
        'branch_code': branch_code
    }
    return axios.request({
        url: '/api/admin/arrange/getUnitCodeList',
        data,
        method: 'post'
    })
}

/**
 * 获取项目列表
 */
export const getProjectList = (branch_code) => {
    const data = {
        'branch_code': branch_code
    }
    return axios.request({
        url: '/api/admin/projectdivision/topList',
        data,
        method: 'post'
    })
}